import { createElement } from "react";

import parse from "html-react-parser";

export default function reStructSEO(seo) {
  const fullHead = seo.fullHead.split("\n").join("");

  return { ...seo, fullHead };
}

export function parseElementList(list) {
  return parse(list).map((item, index) =>
    createElement(item?.type, {
      ...item?.props,
      key: index + 10,
    })
  );
}
